import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, calculateSpacing } from '@vds/theme';
var propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  error: PropTypes.bool,
  inverted: PropTypes.bool,
  //Deprecated
  checked: PropTypes.bool
};
var defaultProps = {
  disabled: false,
  error: false,
  inverted: false //Deprecated
  //error: false

};

var getValidationState = function getValidationState(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      inverted = _ref.inverted;

  if (disabled) {
    return inverted ? colors.coolGray10 : colors.coolGray3;
  }

  if (error && !disabled) {
    return colors.orange;
  }

  return inverted ? colors.white : colors.black;
};

var HitArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "HitArea",
  componentId: "sc-15nzqfl-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  transform: translate(-50%, -25%);\n  text-align: center;\n  cursor: ", ";\n  height: ", ";\n  width: ", ";\n"])), calculateRem(10), function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
}, calculateRem(44), calculateRem(44));
var StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-15nzqfl-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  margin-right: ", ";\n"])), calculateSpacing('3X', 'rem'));
var StyledOuterCircle = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledOuterCircle",
  componentId: "sc-15nzqfl-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  align-items: center;\n  border-color: ", ";\n  border-style: solid;\n  box-sizing: border-box;\n  border-width: ", ";\n  border-radius: 50%;\n  box-shadow: ", ";\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: ", ";\n\n  &:hover {\n    ", ";\n  }\n"])), function (props) {
  return getValidationState(props);
}, function (props) {
  return props.error ? calculateRem(2) : calculateRem(1);
}, function (props) {
  return props.error && !props.disabled ? "0 0 0 ".concat(calculateRem(1), " ").concat(colors.orange) : "none";
}, calculateRem(20), calculateRem(20), function (_ref3) {
  var error = _ref3.error,
      inverted = _ref3.inverted;
  return !error && "\n      box-shadow: 0 0 0 ".concat(calculateRem(1), " ").concat(inverted ? colors.white : colors.black, ";\n    ");
});
var StyledInnerCircle = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledInnerCircle",
  componentId: "sc-15nzqfl-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 50%;\n  box-sizing: border-box;\n  height: 50%;\n  left: 50%;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 50%;\n"])), function (_ref4) {
  var disabled = _ref4.disabled,
      inverted = _ref4.inverted;
  return disabled ? inverted ? colors.coolGray10 : colors.coolGray3 : inverted ? colors.white : colors.black;
});
/**
 * @ignore
 */

var RadioButtonIcon = function RadioButtonIcon(props) {
  var styleConfig = props.styleConfig,
      disabled = props.disabled,
      inverted = props.inverted;
  var selected = props.checked || props.selected || false;
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(HitArea, {
    disabled: disabled
  }), /*#__PURE__*/React.createElement(StyledOuterCircle, _extends({}, props, {
    className: "radioOuter",
    focusable: "false",
    "aria-hidden": true,
    inverted: inverted
  }), selected && /*#__PURE__*/React.createElement(StyledInnerCircle, {
    disabled: disabled,
    inverted: inverted
  })));
};

RadioButtonIcon.defaultProps = defaultProps;
RadioButtonIcon.propTypes = propTypes;
export default RadioButtonIcon;